const manutencao_estudo_sem_escolaridade = {
  path: "/manutencao-de-estudo-sem-escolaridade",
  redirect: "/manutencao-de-estudo-sem-escolaridade",
  meta: {
    breadCrumb:
      "Parâmetros de Escolaridade - Manutenção Estudo sem Escolaridade",
  },
  children: [
    {
      path: "/manutencao-de-estudo-sem-escolaridade",
      name: "manutencao_de_estudo_sem_escolaridade",
      meta: {
        allowedPermissions: ["sem_escolaridade_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeEstudoSemEscolaridade/ManutencaoDeEstudoSemEscolaridade.vue"
        ),
    },
    {
      path: "/manutencao-de-estudo-sem-escolaridade/:id",
      name: "manutencao_de_estudo_sem_escolaridade_edit",
      meta: {
        allowedPermissions: ["sem_escolaridade_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeEstudoSemEscolaridade/ManutencaoDeEstudoSemEscolaridadeEdit.vue"
        ),
    },
    {
      path: "/manutencao-de-estudo-sem-escolaridade/novo",
      name: "manutencao_de_estudo_sem_escolaridade_cad",
      meta: {
        allowedPermissions: ["sem_escolaridade_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeEstudoSemEscolaridade/ManutencaoDeEstudoSemEscolaridadeCad.vue"
        ),
    },
  ],
};

export { manutencao_estudo_sem_escolaridade };
